import type { ServiceLinkEntry } from "@/lib/serviceLinkTypes";

/**
 * Batch 61 — GoHighLevel expert VA Philippines exact-match cluster service links.
 *
 * Every Batch 61 article routes its primary commercial link to
 * /gohighlevel-revops-architect. The answer-first leads in batch61Content.ts
 * embed the link directly, but the lead-swap idempotency guard can drop the
 * lead when the Quick Answer duplicates the lead text. This map is the
 * RELIABLE fallback: `injectBatchServiceLink` (batchContentOptimizer.ts) wraps
 * the first in-body occurrence of each anchor phrase in a
 * /gohighlevel-revops-architect link, so the contextual service link always
 * renders regardless of the lead swap.
 *
 * Anchors are distinctive body phrases (not in the H1) so the link injects
 * into the article body, never the headline.
 */
export const BATCH61_SERVICE_LINKS: Record<string, ServiceLinkEntry> = {
  "gohighlevel-expert-va-philippines": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /general VA with no GoHighLevel build is a VA who stalls on the system/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "hire-gohighlevel-va-philippines": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /certified user with a badge and no snapshot is a user who caps at the toggle/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "gohighlevel-virtual-assistant-philippines-cost": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /general VA at \$8 an hour who ships no snapshot is a VA who caps at the data entry/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "best-gohighlevel-va-philippines": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /certified VA with a badge and no portfolio is a VA who cannot ship the system/i,
    label: "hire a GoHighLevel RevOps architect",
  },
};
